
<main class="main-container" role="main" clvFontObserver [fontStack]="['Hind Guntur']">
    <router-outlet></router-outlet>
</main>
